import React from 'react';
import { Box, Button, Spinner, Stack } from '@stitch-fix/mode-react';
import { Heading, PanelLayout } from '../../../../components/OnboardingNavigation';
import { businessLineData } from './data';
import styles from './styles.module.scss';
import { CloudinaryImageV2 } from '../../../../components/CSCloudinaryAsset';
import type { CapitalizedBusinessLine } from '../../../../components/SocialButtons/SocialButtons';
type BusinessLineProps = {
  onSubmit: (businessLine: CapitalizedBusinessLine) => void;
  isLoading?: boolean;
  activeBusinessLine?: CapitalizedBusinessLine;
  footer?: React.ReactNode;
  title?: React.ReactNode;
};
const BUSINESS_LINE_OPTIONS: CapitalizedBusinessLine[] = ['Womens', 'Mens', 'Kids'];
export const BusinessLine = ({
  onSubmit,
  isLoading,
  activeBusinessLine,
  footer,
  title = 'What can we style you for?'
}: BusinessLineProps) => {
  return <PanelLayout align="top" maxWidth="864px">
      <div className={styles.imagesContainer}>
        {businessLineData.images.map(({
        image,
        alt,
        style
      }) => <div key={image.path} className={styles.imageContainer} style={{
        // animationDelay: `${style.animationDelay}s`,
        animationDuration: `${style.animationDuration}s`,
        zIndex: style.zIndex,
        top: `${style.top}px`,
        // @ts-ignore css variable are not typed
        '--desktop-animation-delay': `${style.animationDelay}s`,
        '--mobile-animation-delay': `${style.mobileAnimationDelay}s`
      }}>
            <CloudinaryImageV2 alt={alt} imageProps={{
          className: styles.image,
          style: {
            width: '118px'
          }
        }} cloudinaryAsset={image} maxContainerWidth={864} sizes={[{
          minWidth: 0,
          staticWidth: 118
        }]} />
          </div>)}
      </div>
      <Box style={{
      justifyItems: 'center'
    }}>
        {typeof title === 'string' ? <Heading title={title} /> : title}
      </Box>
      <Stack spacing={1} maxWidth="332px" mx="auto">
        {BUSINESS_LINE_OPTIONS.map(businessLine => <Button key={businessLine} variant="outline" width="fill" onClick={() => onSubmit(businessLine)} disabled={isLoading} endIcon={isLoading && businessLine === activeBusinessLine ? <Spinner size="xsmall" /> : undefined}>
            {businessLine}
          </Button>)}
      </Stack>
      {footer}
    </PanelLayout>;
};